export enum CheckboxTypes {
	PRIMARY = 'PRIMARY',
	SUCCESS = 'SUCCESS'
}
export enum CheckboxSize {
	LARGE = 'LARGE',
	MEDIUM = 'MEDIUM'
}
